import getRuntimeConstants from "../../runtimeConstants";
import {
  addToWishlistTemplate,
  pageLoadMixAndMatchTemplate,
  pageLoadSingleProductTemplate,
  addToCartSingleProductTemplate,
  addToCartMultipleProductTemplate,
} from "./marketingTrackingTemplates";
import { pushToDataLayer } from "../../utils/pushToDataLayer";

export const fireSaveForLaterMarketing = (product, variantsAdded) => {
  pushToDataLayer(
    addToWishlistTemplate({
      product,
      variantsAdded,
    })
  );
};

export const fireAddToBagMarketing = ({ products, variantsAddedList }) => {
  const { isMixAndMatch } = getRuntimeConstants();

  if (variantsAddedList.length < 1 || !products) {
    return;
  }

  if (isMixAndMatch && variantsAddedList.length > 1) {
    pushToDataLayer(
      addToCartMultipleProductTemplate({
        products,
        variantsAddedList,
      })
    );
    return;
  }

  pushToDataLayer(
    addToCartSingleProductTemplate({
      products,
      variantAdded: variantsAddedList[0],
    })
  );
};

export const firePageLoadMarketing = async ({ products }) => {
  const { isMixAndMatch, hostAndPath, urlParams } = getRuntimeConstants();

  if (!products) {
    return;
  }

  const config = { hostAndPath, urlParams };
  if (isMixAndMatch) {
    pushToDataLayer({
      view_item: pageLoadMixAndMatchTemplate(products, config),
    });
    return;
  }

  if (!products.variants.length) {
    return;
  }
  pushToDataLayer({
    view_item: pageLoadSingleProductTemplate(products, config),
  });
};
